import {
  faBriefcaseClock,
  faCog
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import DashboardLayout from "./DashboardLayout";
import GlobalCandidateSettings from "./GlobalCandidateSettings";
import Jobpreference from "./jobpreference/Jobpreference";
import Skills from "./jobpreference/Skills";

const BASE_API_URL = process.env.REACT_APP_API_URL;

const JobPreferences = () => {
  const location = useLocation();
  const userId = location.state?.userId;
  const preference = location.state?.preference;
  const [activeTab, setActiveTab] = useState(
    preference ? preference.toLowerCase() : "preference"
  );
  const [isNewJobsApplied, setIsNewJobsApplied] = useState(false);
  const [applyjobs, setApplyJobs] = useState([]);
  const [hasUserApplied, setHasUserApplied] = useState({});

  const applyJob = async (jobId, resumeId) => {
    let loadingPopup;

    try {
      // Show loading message using SweetAlert
      loadingPopup = Swal.fire({
        title: "Applying to the job...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const appliedOn = new Date(); // Get current date and time
      const year = appliedOn.getFullYear(); // Get the full year (e.g., 2024)
      const month = String(appliedOn.getMonth() + 1).padStart(2, "0"); // Get month (January is 0, so we add 1)
      const day = String(appliedOn.getDate()).padStart(2, "0"); // Get day of the month

      const formattedDate = `${year}-${month}-${day}`;

      const response = await axios.put(`${BASE_API_URL}/applyJob`, null, {
        params: { jobId, userId, formattedDate, resumeId },
      });

      if (response.data) {
        setApplyJobs((prevApplyJobs) => [
          ...prevApplyJobs,
          { jobId, formattedDate },
        ]);
        setHasUserApplied((prev) => ({ ...prev, [jobId]: true }));

        setIsNewJobsApplied((prev) => !prev);
        // Close the loading popup
        Swal.close();

        // Show success message
        await Swal.fire({
          icon: "success",
          title: "Apply Successful!",
          text: "You have successfully applied for this job.",
        });
      }
    } catch (error) {
      console.error("Error applying for job:", error);
      // Close loading popup on error
      if (loadingPopup) {
        Swal.close();
      }
      // Show error message
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong! Please try again later.",
      });
    } finally {
      // Ensure loading popup is closed if still open
      if (loadingPopup) {
        Swal.close();
      }
    }
  };
  const customTabHeader = (title, icon) => (
    <div className="d-flex align-items-center">
      <span className="me-2">{icon}</span>
      <span class="fs-6 fw-bold">{title}</span>
    </div>
  );
  return (
    <DashboardLayout>
      <div className="main-content">
        <Row
          className="d-flex justify-content-between align-items-center"
          style={{ marginBottom: "20px" }}
        >
          <Col xs="auto">
            <h2
              className="text-start"
              style={{ paddingLeft: "12px", marginBottom: 0 }}
            >
              Job Preferences
            </h2>
          </Col>
          <Col xs="auto">
            <GlobalCandidateSettings
              userId={userId}
              isSomeChanges={isNewJobsApplied}
            />
          </Col>
        </Row>
        <Tabs
          className="preference-tabs"
          defaultActiveKey="preference"
          id="controlled-tab-example"
          activeKey={activeTab}
          onSelect={(key) => setActiveTab(key)}
        >
          <Tab
            eventKey="preference"
            title={customTabHeader(
              "Job Preference",
              <FontAwesomeIcon icon={faBriefcaseClock} />
            )}
          ></Tab>
          <Tab
            eventKey="skills"
            title={customTabHeader("Skills", <FontAwesomeIcon icon={faCog} />)}
          ></Tab>

          {/* <Tab
            eventKey="social profile links"
            title={customTabHeader(
              "Social Profile Links",
              <FontAwesomeIcon icon={faLink} />
            )}
          ></Tab> */}
        </Tabs>
        {activeTab === "preference" && (
          <>
            <div className="candidate-profile-details">
              <Jobpreference userId={userId} />
            </div>
          </>
        )}
        {activeTab === "skills" && (
          <>
            <div className="candidate-profile-details">
              <Skills userId={userId} />
            </div>
          </>
        )}

        {/* {activeTab === "social profile links" && (
          <>
            <SocialProfileLinks state={{ userId: userId }} />
          </>
        )} */}
      </div>
    </DashboardLayout>
  );
};

export default JobPreferences;
